import React from 'react';

function Loading(props) {
 
    return (
    <div>
        {
                props.small ?
                <div className="loading centered">
                    <img src="/images/loadingsmall2.svg"
                    width="80"
                    height="80"
                    viewBox="0 0 80 80"
                    alt="Loading"
                    />
                    </div> :

                    props.css ?
                        <div className="centered">
                            <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                        </div>
                        :
                <div className="loading centered">
                    <img src="/images/Loading.svg"
                        width="200"
                        height="200"
                        viewBox="0 0 200 200"
                        alt="Loading"
                    />
                </div>
            }
    </div>
    );

}

export default Loading;
